import {
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";
import {
  Home,
  ServicePage,
  NotFound,
  Portfolio,
  AboutUs,
  ContactPage,
  WebDevForms,
  BootCamp,
  Enroll,
  BlenderCourse,
  GraphicDesign,
  MobileDevelopment,
  WebDevelopment,
  UiUx,
  DataAnalytics,
  FrontEndWebDevelopment,
  FaqPage,
  UsefulLinks,
  OurServices,
  Booking,
  ComingSoon,
} from "./pages";
import AdminRedirect from "./components/AdminRedirect";

import Layout from "./Layouts/Layout";
import { Toaster } from "react-hot-toast";
import AdminLayout from "./Layouts/CMSLayout";
import AdminPage from "./pages/content";

const CMSWrapper = () => {
  return (
    <>
      <AdminLayout>
        <Outlet />
      </AdminLayout>
    </>
  );
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      {/* <Route path="*" element={<ComingSoon />} /> */}
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/our-services" element={<OurServices />} />
        <Route path="/useful-links" element={<UsefulLinks />} />
        <Route path="/contact-us" element={<ContactPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/admin" element={<AdminRedirect />} />
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path="/content" element={<CMSWrapper />}>
        <Route index element={<AdminPage />} />
        <Route path="*" element={<Navigate to="/content" replace />} />
      </Route>
    </Route>
  )
);

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" />
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
